import { render } from "./move-document-modal.vue?vue&type=template&id=8c3cf9d4"
import script from "./move-document-modal.vue?vue&type=script&lang=js"
export * from "./move-document-modal.vue?vue&type=script&lang=js"

import exportComponent from "../../../../../../../../node_modules/rspack-vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__